import FlexGrid, { FlexGridColumn } from '../../../../../../../ReactSharedScripts/components/FlexGrid';
import { MovingGradient } from '../../../../../../../ReactSharedScripts/components/MovingGradient';
import PaddingBox from '../../../../../../../ReactSharedScripts/components/PaddingBox';
import { codes } from '../../../../../../../ReactSharedScripts/data/translations';
import {
	CommunitiesListItemCounters,
} from '../../../../../../../ReactSharedScripts/modules/communities/list/components/CommunitiesListItem';
import {
	generateListItems,
	getRandomBoundary,
} from '../../../../../../../ReactSharedScripts/modules/list/listPage/ListLoadingPlaceholder/utils';
import { useTranslationAPI } from '../../../../../../../ReactSharedScripts/modules/translations';
import { ListTile } from '../../../../list/components/ListTiles/ListTile';
import { ListTileContentLayout } from '../../../../list/components/ListTiles/ListTileContentLayout';
import { ListTileImageLayout } from '../../../../list/components/ListTiles/ListTileImageLayout';
import { ListTiles } from '../../../../list/components/ListTiles/ListTiles';
import { RouteLink } from '../../../../../../../ReactSharedScripts/components/RouteLink';

type CommunitiesListLoadingPlaceholderListItemsProps = {
	rowsCount?: number;
	hasLinkButton?: boolean;

	skipMembersCount?: boolean;
	skipNewsCount?: boolean;
	skipCommentsCount?: boolean;
	skipAttachmentsCount?: boolean;
};

export function CommunitiesListLoadingPlaceholderListItems({
	rowsCount = 7,
	hasLinkButton,
	skipMembersCount,
	skipNewsCount,
	skipCommentsCount,
	skipAttachmentsCount,
}: CommunitiesListLoadingPlaceholderListItemsProps) {
	const listItems = generateListItems(rowsCount);
	const { translate } = useTranslationAPI();

	return (
		<ListTiles
			style={{
				minWidth: '620px',
			}}
		>
			{listItems.map((_, listItemIndex) => {
				return (
					<ListTile
						key={listItemIndex}
						disabled
					>
						<ListTileImageLayout>
							<MovingGradient
								height='44px'
								width='44px'
							/>
						</ListTileImageLayout>
						<ListTileContentLayout>
							<FlexGridColumn>
								<PaddingBox bottomScanty>
									<MovingGradient
										height='18px'
										width={getRandomBoundary(120, 350)}
									/>
								</PaddingBox>
								<FlexGrid center>
									<FlexGridColumn
										grow
										shrink
									>
										<FlexGrid
											gap='scanty'
											center
										>
											<MovingGradient
												height='16px'
												width={getRandomBoundary(70, 150)}
											/>
										</FlexGrid>
									</FlexGridColumn>
									<FlexGridColumn
										noGrow
										noShrink
									>
										<MovingGradient
											height='16px'
											width='70px'
										/>
									</FlexGridColumn>
								</FlexGrid>
							</FlexGridColumn>
							<FlexGridColumn
								grow
								shrink
							>
								<PaddingBox vrSmall>
									<MovingGradient
										height='16px'
										width={getRandomBoundary(140, 460)}
									/>
								</PaddingBox>
							</FlexGridColumn>
							<FlexGridColumn>
								<FlexGrid center gap='small'>
									<FlexGridColumn>
										<MovingGradient
											height='16px'
											width={getRandomBoundary(70, 100)}
										/>
									</FlexGridColumn>
									<FlexGridColumn
										grow
										shrink
									>
										<CommunitiesListItemCounters
											membersCount={skipMembersCount ? undefined : 0}
											newsCount={skipNewsCount ? undefined : 0}
											commentsCount={skipCommentsCount ? undefined : 0}
											attachmentsCount={skipAttachmentsCount ? undefined : 0}
										/>
									</FlexGridColumn>
									{hasLinkButton && (
										<FlexGridColumn>
											<RouteLink
												size='small'
												styledButton
												noUnderline
												disabled
											>
												{translate(codes.common.open)}
											</RouteLink>
										</FlexGridColumn>
									)}
								</FlexGrid>
							</FlexGridColumn>
						</ListTileContentLayout>
					</ListTile>
				);
			})}
		</ListTiles>
	);
}
